import { useState } from "react";
import { Button } from "@/components/ui/button";
import { GradientButton } from "@/components/ui/gradient-button";
import { Input } from "@/components/ui/input";
import { useToast } from "@/components/ui/use-toast";
import { supabase } from "@/integrations/supabase/client";
import { Link } from "react-router-dom";
import { Separator } from "@/components/ui/separator";
import { PortugalMap } from "./PortugalMap";

export const Footer = () => {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { toast } = useToast();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const { error } = await supabase
        .from('newsletter_subscriptions')
        .insert([{ email }]);

      if (error) throw error;

      toast({
        title: "Subscrito com sucesso!",
        description: "Irás receber as melhores oportunidades no teu email.",
      });
      setEmail("");
    } catch (error) {
      toast({
        variant: "destructive",
        title: "Erro na subscrição",
        description: "Por favor tenta novamente mais tarde.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <footer className="bg-gray-50 border-t">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-8 md:gap-12">
          {/* Newsletter Section */}
          <div className="space-y-4 sm:col-span-2">
            <h3 className="text-xl font-bold">Recebe Oportunidades Gratuitas</h3>
            <p className="text-gray-600">
              Subscreve a nossa newsletter para receberes as melhores oportunidades directamente no teu email.
            </p>
            <form onSubmit={handleSubmit} className="flex gap-2">
              <Input
                type="email"
                placeholder="O teu email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="max-w-xs"
              />
              <GradientButton 
                type="submit" 
                disabled={isLoading}
              >
                {isLoading ? "A subscrever..." : "Subscrever"}
              </GradientButton>
            </form>
          </div>

          {/* Portugal Map Section */}
          <div className="flex items-center justify-center h-full sm:h-32 md:h-40">
            <div className="w-full max-w-[200px] sm:max-w-full">
              <PortugalMap />
            </div>
          </div>
        </div>

        {/* Separator */}
        <Separator className="my-8" />

        {/* AI Coach Section */}
        <div className="space-y-4">
          <h3 className="text-xl font-bold">AI Acting Coach</h3>
          <p className="text-gray-600">
            És Actor e queres um Coach Personalizado 24/7 contigo?
          </p>
          <Button 
            asChild
            className="bg-[#FFE100] hover:bg-[#FFE100]/90 text-black"
          >
            <Link 
              to="https://acting-coach-ai.lovable.app/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Experimenta o AI Acting Coach
            </Link>
          </Button>
        </div>
      </div>
    </footer>
  );
};